import { v4 as uuidv4 } from 'uuid'
import { UserTreatment } from './UserTreatment'

export interface UserTreatmentDTO {
  id: string | undefined
  treatmentID: string
  startDate: Date
  endDate: Date | null
  startCron?: Date | null
  endCron?: Date | null
  duration: number
  frequency: number
  quantity: number
  reason: string
  userID: string
  creatorID?: string
  currently: boolean
}

export function emptyUserTreatmentDTO(userID: string) {
  return {
    id: uuidv4(),
    treatmentID: '',
    startDate: new Date(),
    endDate: null,
    startCron: null,
    endCron: null,
    duration: 0,
    frequency: 0,
    quantity: 1,
    reason: '',
    creatorID: '',
    userID,
    currently: false,
  }
}

export function fromModel(d: UserTreatment): UserTreatmentDTO {
  return {
    id: d.id,
    treatmentID: d.treatmentID,
    startDate: d.startDate,
    endDate: d.endDate,
    startCron: d.startCron,
    endCron: d.endCron,
    duration: d.duration,
    frequency: d.frequency,
    quantity: d.quantity,
    reason: d.reason,
    userID: d.userID,
    creatorID: d.creatorID,
    currently: d.currently,
  }
}

export function toModel(d: UserTreatmentDTO): UserTreatment {
  return new UserTreatment(d)
}
